<template>
      <div class="markup">
        <div class="markup__subtitle markup__subtitle_head">ТТ Формат Адаптивный Banner (статичное изображение/анимация)</div>
        <ul class="markup__ul markup__ul_clear">
          <li>
            <div class="markup__h markup__h_4">
              1. В качестве креатива должен быть предоставлен валидный HTML-код или ссылка на него
            </div>
          </li>
          <li>
            <div class="markup__h markup__h_4">
              2. Для трекинга событий на нашей стороне <strong>клиенту необходимо</strong> внутри баннера:
            </div>
            <ul class="markup__ul markup__ul_nested">
              <li>загружать скрипт <strong>https://tube.buzzoola.com/js/lib/banner.js</strong></li>
              <li>
                вызывать метод <strong>buzzTrack() / window.buzzTrack()</strong> и передавать туда события:
                <ul class="markup__ul markup__ul_nested">
                  <li><strong>loaded</strong> - после успешной загрузки баннера</li>
                  <li><strong>click</strong> - при совершении перехода</li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <div class="markup__h markup__h_4">
              3. Креатив должен быть адаптивным <strong>по ширине и высоте</strong>
            </div>
          </li>
          <li>
            <div class="markup__h markup__h_4">
             4. Фон баннера не должен быть прозрачным. При наличии однородного светлого фона необходима черная рамка 1px
            </div>
          </li>
          <li>
            <div class="markup__h markup__h_4">
             5. При наведении на баннер курсор мыши должен меняться на pointer
            </div>
          </li>
          <li>
            <div class="markup__h markup__h_4">
             6. Необходимо нанести на баннер кнопку Call-To-Action
            </div>
          </li>
        </ul>

        <div class="attention attention_warn">
          <div class="attention__title">Размещение кодом Weborama</div>
          <p>У Weborama есть готовый согласованный с нами шаблон с вшитым трекингом Buzzoola. Для корректной сборки баннера необходимо сообщить Weborama, что размещение кода планируется в Buzzoola и в зависимости от формата исходных материалов (изображения или html-баннер) они смогут подобрать нужный шаблон.</p>
        </div>
        <div class="html2pdf__page-break"/>
        <br>
        <div class="markup__h markup__h_4 markup__h_orange">
          <strong>Пример кода адаптивного баннера с трекингом и подключенной библиотекой:</strong>
        </div>
        <banner-example-adaptive></banner-example-adaptive>

        <br>
        <marked-zone-atention></marked-zone-atention>
      </div>
</template>

<script>
import markedZoneAtention from '@/components/documentation/markedZoneAtention.vue';
import bannerExampleAdaptive from '@/components/documentation/bannerExampleAdaptive.vue';

export default {
  name: 'adaptiveBanner',
  components: {
    markedZoneAtention,
    bannerExampleAdaptive,
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang='stylus'>
@import '../../../styles/darcula.min.css'
@import '../../../styles/main.styl'
@import '../../../styles/documentation_article_markup.styl'

</style>
